/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconFallDown: {
  name: 'fall_down';
  data: string;
} = {
  name: 'fall_down',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M60.115 449.352a4.781 4.781 0 1 1-9.562 0 4.781 4.781 0 0 1 9.562 0zM52.943 458.914c0-2.391 0-2.391 2.391-2.391s2.391 0 2.391 2.391v16.734h4.782l-7.172 7.172-7.172-7.172h4.782v-16.734h-.002z" transform="matrix(15 0 0 15 -524 -6649.433)"/></svg>`,
};
